import React, {useEffect} from "react";
import {storyblokEditable} from "@storyblok/react";
import ProvenProcessStepImage from "../partials/ProvenProcessStepImage";

export default function ProvenProcess({blok}: { blok: any }) {
    // const [ref, inView, entry] = useInView({threshold: 0.1});

    const [currentStepClass, setCurrentStepClass] = React.useState('step1');
    const [currentStep, setCurrentStep] = React.useState(1);
    const [stopInterval, setStopInterval] = React.useState(false);

    const stepCallback = (newStep: number) => {
        setCurrentStep(newStep);
        setCurrentStepClass('step' + newStep)
        setStopInterval(true);
    }

    React.useEffect(() => {
        const interval = setInterval(() => {
            if (stopInterval) {
                clearInterval(interval);
                return;
            }

            if (currentStep >= 4) {
                setCurrentStep(1);
                setCurrentStepClass('step1')

            } else {
                setCurrentStep(currentStep + 1);
                setCurrentStepClass('step' + (currentStep + 1))

            }

        }, 5000);


        return () => {
            clearInterval(interval);
        };
    })

    return <div {...storyblokEditable(blok)} className={blok.class}>
        <div className="mx-auto max-w-screen-7xl px-4 sm:px-6 lg:px-8 my-12 py-12 sm:py-12">

            <style className="rich-text"
                 dangerouslySetInnerHTML={{
                     __html: `#endStep, #startStep {
  position: absolute;
  width: 15%;
  left: 85%;
  transition: opacity .5s;
  opacity: 0;
}

#startStep {
  left: 0;
  transform: rotate(180deg);
}

#endStep.step4 {
  opacity: 1;
}

#startStep.step1 {
  opacity: 1;
}

#waveStep {
  position: absolute;
  transition: all .5s ease-in-out;
}

#waveStep.step1 {
  width: 30%;
  left: 10%;
}

#waveStep.step2 {
  width: 30%;
  left: 35%;
}

#waveStep.step3 {
  width: 30%;
  left: 60%;
}

#waveStep.step4 {
  width: 30%;
  left: 60%;
}`
                 }}
            >
            </style>

            <section className="timeline-secondary position-relative py-5 my-md-5 bg-alt">
                <div className="pb-5">
                    <div className="text-center">
                        <div>
                            <div className="mx-auto max-w-prose text-base lg:max-w-none">
                                <h2 className="text-lg font-semibold text-secondary">
                                    You can rely on our proven process.
                                </h2>
                                <p className="mt-2 text-3xl font-bold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                                    Why work with us?
<br/>
                                    Fast Kickoff. Quick Turnaround.
                                    U.S. based Development.
                                </p>
                            </div>
                            <div className="my-6 relative z-10 mx-auto max-w-prose text-base text-center">
                                <p className="text-lg text-gray-500">
                                    We have been in the business of custom web &amp; software development for over 15
                                    years.
                                    Trust our proven process for a successful project realization.
                                </p>
                            </div>

                        </div>

                    </div>

                    <div className={'max-w-4xl mx-auto relative my-8'}>
                        <svg id="waveStep" className={currentStepClass} data-name="Layer 2"
                             xmlns="http://www.w3.org/2000/svg"
                             viewBox="0 0 144.85 46.67">
                            <g id="waveLayer" data-name="Layer 1">
                                <path
                                    d="M12.85,26.05c9-.18,16.9,2.97,23.25,7.96,10.44,8.2,23.52,12.67,36.8,12.67h.71c13.46,0,26.44-4.84,37.14-12.99,5.88-4.48,13.18-7.44,21.1-7.62V.03c-14.36.09-27.56,5.02-38.06,13.26-12.26,9.63-29.66,9.28-41.99-.27C41.08,4.72,27.85-.14,12.85.04v26.01Z"/>
                                <circle cx="131.85" cy="13.01" r="13.01"/>
                                <circle cx="13.01" cy="13.03" r="13.01"/>
                            </g>
                        </svg>

                        <svg id="startStep" className={currentStepClass} data-name="Layer 2"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.43 124.6">
                            <g id="endStepLayer" data-name="Layer 1">
                                <g>
                                    <path
                                        d="M13.01,0v25.98s.87.03,1.3.06c17.82,1.31,32.19,15.74,33.46,33.56,1.48,20.76-14.76,38.13-34.76,38.94v25.97c33-1.54,59.92-29.34,59.41-63.22C71.93,28.53,46.01,1.5,13.01,0Z"/>
                                    <circle cx="13.01" cy="13.01" r="13.01"/>
                                    <circle cx="13.01" cy="111.59" r="13.01"/>
                                </g>
                            </g>
                        </svg>

                        <svg id="endStep" className={currentStepClass} data-name="Layer 2"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.43 124.6">
                            <g id="endStepLayer" data-name="Layer 1">
                                <g>
                                    <path
                                        d="M13.01,0v25.98s.87.03,1.3.06c17.82,1.31,32.19,15.74,33.46,33.56,1.48,20.76-14.76,38.13-34.76,38.94v25.97c33-1.54,59.92-29.34,59.41-63.22C71.93,28.53,46.01,1.5,13.01,0Z"/>
                                    <circle cx="13.01" cy="13.01" r="13.01"/>
                                    <circle cx="13.01" cy="111.59" r="13.01"/>
                                </g>
                            </g>
                        </svg>

                        <ProvenProcessStepImage stepCallback={stepCallback} currentStep={currentStep}/>

                    </div>

                    <div className="max-w-3xl mx-auto relative z-10 mx-auto max-w-prose text-base text-center">

                        <div className={"steps"}>
                            <div className={currentStep === 1 ? '' : 'hidden'}>
                                <b>Step 1: Initial Interview</b><br/>
                                In the initial consultation we get to know you, your objectives and your environment.
                                <br/>
                                We&apos;ll discuss your project, your goals, and your vision. We&apos;ll also discuss
                                your budget and timeline.
                            </div>
                            <div className={currentStep === 2 ? '' : 'hidden'}>
                                <b>Step 2: Requirement Engineering and Proposal</b><br/>
                                Detailed requirements and the project&apos;s scope will be discussed and documented,
                                either by you or with
                                us together.
                                Your needs will be analyzed in detail by us internally and you will receive unbiased and
                                technology-agnostic advice and proposal
                            </div>
                            <div className={currentStep === 3 ? '' : 'hidden'}>
                                <b>Step 3: Development: Planing, Implementation and Testing</b><br/>
                                When development begins you are constantly kept up to date and included in the
                                development status updates.
                                <br/>
                                Testing is constantly being performed to ensure the best results.
                            </div>
                            <div className={currentStep === 4 ? '' : 'hidden'}>
                                <b>Step 4: Delivery</b><br/>
                                Your finished software goes into productive operation and can be used by you.
                                <br/>
                                The next iteration of your project can be planned and discussed.
                            </div>
                        </div>
                    </div>

                    {/*<div className="graph-line-container">*/}
                    {/*    <div ref={ref} className={"graph-line mb-5 " + (inView ? 'graph-line-animated' : '')}>*/}
                    {/*        <div className="grid grid-cols-4">*/}
                    {/*            <div className="col-span-1 relative">*/}
                    {/*                <p className="graph-step-title text-2xl ">Initial Interview</p>*/}
                    {/*                <p className="graph-step-subtitle text-muted mt-12">In the initial consultation we*/}
                    {/*                    get to know*/}
                    {/*                    you, your objectives and your environment.</p>*/}
                    {/*                <div className="graph-step"></div>*/}
                    {/*            </div>*/}
                    {/*            <div className="col-span-1 flex justify-center relative">*/}
                    {/*                <p className="graph-step-title text-2xl ">Requirements Analysis</p>*/}
                    {/*                <p className="graph-step-subtitle text-center text-muted mt-12">Your needs will be*/}
                    {/*                    analyzed in detail by*/}
                    {/*                    us internally and you will receive unbiased and technology-agnostic advice.</p>*/}
                    {/*                <div className="graph-step"></div>*/}
                    {/*            </div>*/}
                    {/*            <div className="col-span-1 flex justify-center relative">*/}
                    {/*                <p className="graph-step-title text-2xl ">Development &amp; Testing</p>*/}
                    {/*                <p className="graph-step-subtitle text-center text-muted mt-12">When development*/}
                    {/*                    begins you are constantly*/}
                    {/*                    kept up to date and included in the development status updates. Testing is*/}
                    {/*                    constantly being performed to ensure the best results.</p>*/}
                    {/*                <div className="graph-step"></div>*/}
                    {/*            </div>*/}
                    {/*            <div className="col-span-1 flex justify-end relative">*/}
                    {/*                <p className="graph-step-title text-2xl ">Delivery</p>*/}
                    {/*                <p className="graph-step-subtitle text-muted text-right mt-12">Your finished*/}
                    {/*                    software goes into*/}
                    {/*                    productive operation and can be used by you.</p>*/}
                    {/*                <div className="graph-step"></div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    {/*<svg className="move-arrows md:hidden h-16" width="24px" height="24px" strokeWidth="1.5"*/}
                    {/*     viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#212121">*/}
                    {/*    <path*/}
                    {/*        d="M17.5 12l2.004 2.672a2 2 0 01-.126 2.552l-3.784 4.127a1.998 1.998 0 01-1.473.649H9.5c-2.358 0-3.622-2.575-3.982-3.93a.55.55 0 01-.018-.143V9.43c0-2.286 3-2.286 3 0v.57"*/}
                    {/*        stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>*/}
                    {/*    <path*/}
                    {/*        d="M11.5 10V8.286c0-2.286-3-2.286-3 0V10M14.5 10V7.5c0-2.286-3-2.286-3 0 0 0 0 0 0 0V10M14.5 10V7.5 3.499A1.5 1.5 0 0116 2v0a1.5 1.5 0 011.5 1.5V15"*/}
                    {/*        stroke="#212121" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>*/}
                    {/*    <path*/}
                    {/*        d="M17.563 6.5h2.062C20.5 6.5 21 6.078 21 5.25 21 4.422 20.5 4 19.625 4H12.25C11.56 4 11 4.56 11 5.25v.25a1 1 0 001 1v0"*/}
                    {/*        stroke="#212121" strokeWidth="1.5"></path>*/}
                    {/*</svg>*/}
                </div>
            </section>
        </div>
    </div>
}
